"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyDeepLinkAction = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../utils/CardHelper");
const deepLink_1 = require("../utils/deepLink");
function SurveyDeepLinkAction(tenantId, surveyType, conversationId, threadId, messageId, parentMessageId) {
    if (conversationId) {
        [threadId, messageId] = conversationId.split(";messageid=");
    }
    let url = "";
    if (parentMessageId) {
        url = (0, deepLink_1.messageDeepLink)({
            threadId,
            messageId,
            tenantId,
            parentMessageId,
        });
    }
    else {
        url = (0, deepLink_1.messageDeepLink)({ threadId, messageId, tenantId });
    }
    return CardHelper_1.CardHelper.create(adaptivecards_1.OpenUrlAction, {
        title: `Go to ${(0, CardHelper_1.getSurveyTypeDisplay)(surveyType)}`,
        url,
    });
}
exports.SurveyDeepLinkAction = SurveyDeepLinkAction;
//# sourceMappingURL=SurveyCommands.js.map